"use client";

import { FC } from "react";
import { useRouter } from "next/navigation";
import { ILoginButton } from "./types";
import Typography from "@portal/components/atoms/v2/typography";
import { TextResources } from "@portal/assets/text/TextResources";

const LoginButton: FC<ILoginButton> = () => {
  const router = useRouter();

  return (
    <button onClick={() => router.push("/auth/signin")}>
      <Typography variant="Bold">{TextResources.LOG_IN_PAGE_TITLE}</Typography>
    </button>
  );
};

export default LoginButton;
